import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, TextField, Box, Divider, Typography } from "@mui/material";

export default function MdlSettingEditAccount({ user, onClose, onRefresh, editUser }) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    username: user.username || "",
    first_name: user.first_name || "",
    last_name: user.last_name || "",
    phone: user.phone || "",
    language: user.language || "de",
    role: user.role !== undefined ? user.role : 1,
    is_active: user.is_active !== undefined ? user.is_active : true,
    password: "" 
  });

  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Typen-Konvertierung für Booleans und Nummern, damit Go es im Struct versteht
    let parsedValue = value;
    if (name === "is_active") parsedValue = value === "true";
    if (name === "role") parsedValue = parseInt(value, 10);

    setFormData(prev => ({ ...prev, [name]: parsedValue }));
  };
  
  const sendRequest = (e) => {
    if (e) e.preventDefault();
    setErrorMsg(""); // ⭐ 1. Fehlermeldung vor dem Versuch leeren

    // Wartet, bis der Redux-Request erfolgreich auf dem Server war
    Promise.resolve(editUser(user.id, formData)) 
      .then(() => {
        if (onRefresh) onRefresh(); 
        onClose(); 
      })
      .catch((err) => {
        console.error("Fehler beim Aktualisieren:", err);
        setErrorMsg(t("MdlSettingEditAccount.statusMsg_sendEditRequest")); 
      });
  };

  return (
    <Box style={{ width: "100%", maxWidth: "460px", height: "90%", maxHeight: "600px", display: "flex", overflowY: "auto", flexDirection: "column", margin: "0 auto", boxSizing: "border-box", paddingRight: "4px" }} >
      {errorMsg && <Typography color="error" variant="body2" sx={{ mb: 2 }}>{errorMsg}</Typography>}
      
	  <form onSubmit={(e) => { 
			e.preventDefault();
			sendRequest();
		}} 
		style={{ display: "flex", flexDirection: "column", gap: "18px" }}
	  >
		<Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
			<Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingEditAccount.subtitle_section_1")}
			</Typography>	
			<TextField
			  fullWidth
			  variant="outlined"
			  size="small"
			  type="password"
			  label={t("MdlSettingEditAccount.password_new")}
			  name="password"
			  value={formData.password}
			  onChange={handleChange}
			  placeholder={t("MdlSettingEditAccount.placeholder_password")}
			/>
        </Box>

        <Divider style={{ margin: "5px 0" }} />

        {/* Sektion 2: Personendaten */}
        <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingEditAccount.subtitle_section_2")}
          </Typography>	
          <TextField fullWidth variant="outlined" size="small" label={t("user.username")} name="username" value={formData.username} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.givenname")} name="first_name" value={formData.first_name} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.lastname")} name="last_name" value={formData.last_name} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.phone")} name="phone" value={formData.phone} onChange={handleChange} />
          	  
		  <TextField
			select fullWidth variant="outlined" size="small"
			label={t("user.language")} name="language"
			value={formData.language} onChange={handleChange}
			SelectProps={{ native: true }} // Gewährleistet vertikales Aufklappen
		  >
			<option value="de">{t("common.langOptionDe")}</option>
			<option value="en">{t("common.langOptionEn")}</option>
		  </TextField>		  
		  
        </Box>	
	
        <Divider style={{ margin: "5px 0" }} />

        <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingEditAccount.subtitle_section_3")}
          </Typography>

		   <TextField
			  select
			  fullWidth
			  variant="outlined"
			  size="small"
			  label={t("user.activity")}
			  name="is_active"
			  value={formData.is_active.toString()}
			  onChange={handleChange}
			  SelectProps={{ native: true }}
			>
			  <option value="true">{t("user.is_active_true")}</option>
			  <option value="false">{t("user.is_active_false")}</option>
			</TextField>

			<TextField
			  select
			  fullWidth
			  variant="outlined"
			  size="small"
			  label={t("user.role")}
			  name="role"
			  value={formData.role.toString()}
			  onChange={handleChange}
			  SelectProps={{ native: true }}
			>
			  <option value="0">0 ({t("user.role_admin")})</option>
			  <option value="1">1 ({t("user.role_user")})</option>
			</TextField>
		</Box>


		<Divider sx={{ my: 0.5 }} />		

        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between", gap: "12px" }}>
          <Button variant="outlined" onClick={onClose} sx={{ borderRadius: "8px", textTransform: "none" }}>{t("common.cancel")}</Button>
          <Button type="submit" variant="contained" sx={{ borderRadius: "8px", backgroundColor: "#4f40b3", color: "white", textTransform: "none", px: 3 }}>
            {t("common.save")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
